import React from "react";
import { Route, Switch } from "react-router-dom";
import AssetsList from "./assetsList";
import AssetsAdd from "./AssetsAdd";
import AssetEdit from "./AssetEdit";
import AssetsColorList from "./AssetsColorList";
import AssetColorAdd from "./AssetColorAdd";
import AssetColorEdit from "./AssetColorEdit";
import CustomPage from "./CustomPage";
import CustomPageAdd from "./CustomPageAdd";
import CustomPageEdit from "./CustomPageEdit";

const designCenterRoutes = (
  <Switch>
    <Route path="/assets/list" component={AssetsList} />
    <Route path="/assets/add" component={AssetsAdd} />
    <Route path="/asset/edit/:assetID?" component={AssetEdit} />
    <Route path="/assets/color/list" component={AssetsColorList} />
    <Route path="/asset/color/add" component={AssetColorAdd} />
    <Route path="/asset/color/edit/:assetColorID?" component={AssetColorEdit} /> 
    <Route path="/asset/custompage/add" component={CustomPageAdd} />
    <Route path="/asset/custompage/edit/:customID?" component={CustomPageEdit} />
    <Route path="/asset/custompage/list" component={CustomPage} />
  </Switch>
);

export default designCenterRoutes;



// WEBPACK FOOTER //
// ./src/app/views/admin/designCenter/designCenterRoute.js